import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoMeetingsIllustration = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 114,
	height: 77,
	viewBox: "0 0 114 77",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 37226",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 300",
				d: "M53.2896 34.8362L53.294 34.1923L52.7097 33.9218L48.2412 31.8534L47.5788 31.5468L47.0849 32.0842L42.7201 36.8334L42.4024 37.1791L42.4655 37.6444L46.6764 68.6983L18.9812 68.6983L13.6754 65.1611L13.4235 64.9932L13.1207 64.9932L1.84754 64.9932L1.84755 46.4243L13.1208 46.4242L13.718 46.4242L14.0012 45.8983L21.4722 32.0234L37.6579 25.4647L37.7077 25.4445L37.7551 25.4191L46.2074 20.8841L61.4117 31.6839L59.1253 45.1934L53.2228 44.5309L53.2896 34.8362Z",
				fill: "white",
				stroke: "#C9D8FC",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 5884",
				d: "M52.0981 43.04C52.0981 36.9649 57.023 32.04 63.0981 32.04H82.6701V66.8611H63.0981C57.023 66.8611 52.0981 61.9362 52.0981 55.8611V43.04Z",
				stroke: "#6B719D",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 5885",
				x: 43.0669,
				y: 35.9629,
				width: 20.4623,
				height: 7.03123,
				fill: "white",
				stroke: "#C9D8FC",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 5883",
				d: "M67.0439 25.5679H113.318V59.0183C113.318 68.4072 105.707 76.0183 96.3184 76.0183H84.044C74.6551 76.0183 67.0439 68.4072 67.0439 59.0183V25.5679Z",
				fill: "#6B719D"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 5888",
				x: 47.528,
				y: 62.3815,
				width: 15.172,
				height: 5.75875,
				transform: "rotate(-5.70381 47.528 62.3815)",
				fill: "white",
				stroke: "#C9D8FC",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 5887",
				x: 42.2639,
				y: 53.9211,
				width: 20.4623,
				height: 7.03123,
				transform: "rotate(-5.70381 42.2639 53.9211)",
				fill: "white",
				stroke: "#C9D8FC",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 5886",
				x: 38.667,
				y: 44.9941,
				width: 24.8621,
				height: 7.03123,
				fill: "white",
				stroke: "#C9D8FC",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 328",
				d: "M85.8959 0.981934L89.5352 8.26041L83.6214 14.6291L85.8959 20.9978",
				stroke: "#F385FF",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 329",
				d: "M94.1592 5.37939L96.7578 10.5767L92.535 15.1244L94.1592 19.672",
				stroke: "#F385FF",
				strokeWidth: 3
			})
		]
	})
});
export default SvgNoMeetingsIllustration;
